<div mat-dialog-header class="title">
    Delete Muckpile
</div>
<div mat-dialog-content>
    <div *ngIf="(muckpiles$ | async) === undefined" class="container centered-content">
        <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
    </div>
    <div *ngIf="(muckpiles$ | async) === null || (muckpiles$ | async)?.length === 0" class="container centered-content">
        <div class="container centered-content">
            <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
            <div>No Data Found</div>
        </div>
    </div>
    <mat-card class="table" *ngIf="(muckpiles$ | async)?.length > 0">
        <mat-table [dataSource]="selectableMuckpiles" class="mat-elevation-z8">
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef class="header"> Muckpile Name </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="delete">
                <mat-header-cell class="action-header" *matHeaderCellDef> Action </mat-header-cell>
                <mat-cell class="action-checkbox" *matCellDef="let element">
                    <mat-checkbox [(ngModel)]="element.selected"></mat-checkbox>
                </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="['name', 'delete']"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ['name', 'delete']"></mat-row>
        </mat-table>
    </mat-card>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="warn" [disabled]="!isDeleteEnabled()" (click)="deleteSelectedMuckpiles()">
        Delete
    </button>
</div>
